import request from '@/plugins/axios.js'
import util from "@/libs/util.js";

export function checkUserForLogin (params) {
  return request({
    url: `${util.UMOOC_SERVER_HOST}/ulearning_web/login!checkUserForLogin.do`,
    method: 'POST',
    params: params
  })
}
export function projectbj (id) {
  return request({
    url: `https://sjjxapi.ulearning.cn/website/project/${id}`,
    method: 'get',
  })
}
export function brandList () {
  return request({
    url: `https://api.ulearning.cn/wholepage/course/3rd/31290`,
    method: 'get'
  })
}
export function online (val) {
  return request({
    url: `${util.API_SERVER_HOST}/portal/portalOnlineCourses?type=${val}`,
    method: 'get',
  })
}
export function courses (declareType) {
  return request({
    url: `${util.API_SERVER_HOST}/portal/courses/index/${declareType}`,
    method: 'get',
  })
}
export function hnnews (params) {
  return request({
    url: `${util.API_SERVER_HOST}/announcement/list`,
    method: 'get',
    params: params
  })
}
export function news (params) {
  return request({
    url: `https://courseapi.tongshike.cn/website/articles`,
    method: 'get',
    params: params
  })
}
export function publicCourses (params) {
  return request({
    url: `https://courseapi.ulearning.cn/publicCourses`,
    method: 'get',
    params
  })
}
export function infomation (id) {
  return request({
    url: `${util.API_SERVER_HOST}/announcement/portal/${id}`,
    method: 'get',
  })
}

export function newsContent (id) {
  return request({
    url: `https://courseapi.tongshike.cn/website/articles/${id}`,
    method: 'get'
  })
}

export function teachers (params) {
  return request({
    url: `https://www.ulearning.cn/websiteManage/api/famousTeacher`,
    method: 'get',
    params: params
  })
}

export function teacherContent (id) {
  return request({
    url: `https://www.ulearning.cn/websiteManage/api/famousTeacher/${id}`,
    method: 'get'
  })
}

export function teacherNews (params) {
  return request({
    url: `https://www.ulearning.cn/websiteManage/api/famousTeacher/${params.domain}/contents`,
    method: 'get',
    params: params
  })
}

export function teacherNewsContent (id) {
  return request({
    url: `https://www.ulearning.cn/websiteManage/api/famousTeacher/contents/${id}`,
    method: 'get'
  })
}

export function spocCourses (params) {
  return request({
    url: `${util.API_SERVER_HOST}/portal/courses`,
    method: 'get',
    params: params
  })
}

export function spocCourseContent (params) {
  return request({
    url: `${util.API_SERVER_HOST}/portal/courses/${params.id}`,
    method: 'get',
  })
}

export function spocCourses2 (params) {
  if (window.location.host.indexOf(".tongshike.cn") !== -1) {
    params.octypeId = 51;
  } else {
    params.octypeId = 3;
  }
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/manager/systemManager/spooc/list`,
    method: 'get',
    params: params
  })
}

export function spocCourseContent2 (id) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/manager/systemManager/spooc/information/${id}`,
    method: 'get'
  })
}

export function subjectList () {
  return request({
    url: `${util.API_SERVER_HOST}/subjects`,
    method: 'get',
  })
}

export function platforms () {
  return request({
    url: `${util.API_SERVER_HOST}/platforms`,
    method: 'get'
  })
}

export function orgList () {
  return request({
    url: `${util.API_SERVER_HOST}/orgs`,
    method: 'get',
  })
}

export function spocSchoolLevel (params) {
  if (params.declareType == 2) {
    return request({
      url: `${util.API_SERVER_HOST}/portal/onlineCourses?istopped=1`,
      method: 'get',
      params: params
    })
  } else {
    return request({
      url: `${util.API_SERVER_HOST}/portal/onlineCourses`,
      method: 'get',
      params: params
    })
  }
}

export function courseClassifyList () {
  return request({
    url: `${util.API_SERVER_HOST}/course/classify/list`,
    method: 'get',
  })
}

export function spocSchoolLevelContent (params) {
  return request({
    url: `${util.API_SERVER_HOST}/portal/onlineCourse/${params.id}`,
    method: 'get',
  })
}


export function login (data) {
  return request({
    url: `${util.API_SERVER_HOST}/users/login`,
    method: 'post',
    data
  })
}

export function toLearn (params) {
  return request({
    url: `${util.API_SERVER_HOST}/onlineCourses/tolearn`,
    method: 'get',
    headers: {
      'Authorization' : util.getCookie('am-token'),
    },
    params
  })
}
// export function unionOrgs(params) {
//   return request({
//     url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/league/getOrgans`,
//     method: 'get',
//     params: params
//   })
// }

export function courseTypes (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/league/website/courseManage/getSubjectClassifyList`,
    method: 'get',
    params: params
  })
}

export function unionCourses (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/league/courses`,
    method: 'get',
    params: params
  })
}

export function resources (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/league/contents`,
    method: 'get',
    params: params
  })
}

export function resourceContent (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/league/contents/detail`,
    method: 'get',
    params: params
  })
}

export function brands () {
  return request({
    url: `https://api.ulearning.cn/wholepage/course/3rd/12950`,
    method: 'get'
  })
}

export function AccountLogin (data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function getResList (params) {
  return request({
    url: `https://rsglapi.ulearning.cn/resources`,
    method: 'get',
    params: params
  })
}

export function getMenuList (params) {
  return request({
    url: `https://courseapi.tongshike.cn/website/menus`,
    method: 'get',
    params: params
  })
}
export function getArticles (params) {
  return request({
    url: `https://courseapi.tongshike.cn/website/articles`,
    method: 'get',
    params: params
  })
}

export function articlesInfo (id) {
  return request({
    url: `https://courseapi.tongshike.cn/website/articles/${id}`,
    method: 'get',
  })
}

// 文华课程思政

// 获取示范课程列表
export function getCourseList (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/courseEducation/findPage`,
    method: 'get',
    params: params
  })
}

// 获取课程详情
export function getCourseDetail (courseId) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/courseEducation/getCourseDetail/${courseId}`,
    method: 'get'
  })
}

// 获取课程分类一级菜单
export function getSubjectList () {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/courseEducation/classify/all`,
    method: 'get',
    params: {
      names: "哲学,经济学,法学,教育学,文学,历史学,理学,工学,农学,医学,军事学,管理学,艺术学,职业教育"
    }
  })
}

// 获取资源列表
export function getResourceList (libraryId) {
  return request({
    url: `https://rsglapi${util.UMOOC_COOKIE_DOMAIN}/resources/getResources/${libraryId}`,
    method: 'get'
  })
}

//获取新闻列表
export function getNewsList (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/news`,
    method: 'get',
    params: params
  })
}

//获取新闻详情
export function getNewsDetail (id) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/news/${id}`,
    method: 'get'
  })
}

//获取新闻热点
export function getHotnewsInwhkcsz (params) {
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/news/recommend/${params.id}`,
    method: 'get',
    params: params
  })
}

export function getUlearningWxJsConfig () {
  let data = {
    url: location.href.split("#")[0]
  };
  return request({
    url: `https://courseapi${util.UMOOC_COOKIE_DOMAIN}/ulearning/jsconfig`,
    method: 'POST',
    data
  })
}
// 网站新闻迁移
// 获取机构id
export function orgDoadmin(domain){
  return request({
    url: `https://websiteapi.ulearning.cn/organ?domain=${domain}`,
    method: 'get'
  })
}
export function menuHomepage(id){
  return request({
    url: `https://websiteapi.ulearning.cn/menu/homepage?orgId=${id}`,
    method: 'get'
  })
}
export function menuList(id){
  return request({
    url: `https://websiteapi.ulearning.cn/menu/list?orgId=${id}`,
    method: 'get'
  })
}
//获取首页文章
export function getArticleList(params) {
  return request({
    url: `https://websiteapi.ulearning.cn/article/list`,
    method: "get",
    params
  });
}
//文章详情
export function articleFindone(id) {
  return request({
    url: `https://websiteapi.ulearning.cn/article/findOne?id=${id}`,
    method: "get"
  });
}
//福建开放动态获取思政数据库
export function getRepository(query) {
  return request({
    url: `https://rsglapi.ulearning.cn/resources`,
    method: "get",
    params: query
  });
}
